import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import React from "react";
import moment from "moment";
import { formatLength } from "../../../../constants";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import { interactionsContainerStyles } from "./styles";

const CreateQTDetailsInteractionsFieldsSection = ({
  quicktaleDetails,
  setQuicktaleDetails,
}) => {
  return (
    <Grid container style={interactionsContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*Creation Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Creation Date"}
          value={
            quicktaleDetails?.createdAt &&
            moment
              .unix(quicktaleDetails?.createdAt.seconds)
              .format("MM/DD/YYYY HH:mm:ss")
          }
          disabled={true}
        />
        {/*Geo Hash section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Geohash"}
          value={quicktaleDetails?.g?.geohash || ""}
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Modified Status Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Status Change Date"}
          value={
            quicktaleDetails?.approvalStatus?.updatedAt &&
            moment
              .unix(quicktaleDetails?.approvalStatus?.updatedAt.seconds)
              .format("MM-DD-YYYY HH:mm:ss")
          }
          disabled={true}
        />
        {/*Length section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Length"}
          value={
            quicktaleDetails.audioLength
              ? formatLength(quicktaleDetails.audioLength)
              : ""
          }
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default CreateQTDetailsInteractionsFieldsSection;
